<section class="empty-state" role="status">
  <ion-icon class="empty-state-icon" [name]="icon" aria-hidden="true"></ion-icon>
  <h2>{{ title }}</h2>
  <p>{{ message }}</p>
  <ion-button *ngIf="showAction" class="empty-state-action" shape="round" color="primary" (click)="action.emit()">
    <ion-icon slot="start" [name]="actionIcon" aria-hidden="true"></ion-icon>
    {{ actionLabel }}
  </ion-button>
</section>